import Axios from 'axios'

export default class Api {

  constructor(ressourceName) {
    this.ressourceName = ressourceName
  }

  getAll(filter) {
    return Axios.get(this.ressourceName, {params: filter})
  }

  get(id) {
    return Axios.get(`${this.ressourceName}/${id}`)
  }

  post(data, url) {
    return Axios.post(`${this.ressourceName}${url}`, data)
  }

  put(id, data, url) {
    return Axios.put(`${this.ressourceName}${url}/${id}`, data)
  }

  upload(id, data, name) {
    return Axios.put(`${this.ressourceName}/${id}/${name}`, data, { headers: {'Content-Type': 'multipart/form-data' }})
  }

  delete(id) {
    return Axios.delete(`${this.ressourceName}/${id}`)
  }

  deleteSubElement(id, sub, subId) {
    return Axios.delete(`${this.ressourceName}/${id}/${sub}/${subId}`)
  }


  deleteMany(list) {
    return Axios.delete(this.ressourceName, {params: {toDelete: list}})
  }
}